import React, { createContext, useContext, useState, useMemo, useCallback, useEffect } from 'react';

const ThemeContext = createContext();

export const useThemeContext = () => useContext(ThemeContext);

export const ThemeContextProvider = ({ children }) => {
  // Initialize from localStorage
  const [theme, setTheme] = useState(() => {
    try {
      return localStorage.getItem('theme') || 'light';
    } catch (error) {
      return 'light';
    }
  });

  // Memoize updateTheme function
  const updateTheme = useCallback((newTheme) => {
    localStorage.setItem('theme', newTheme);
    setTheme(newTheme);
  }, []);

  // getCurrentTheme should just return the state
  const getCurrentTheme = useCallback(() => {
    return theme;
  }, [theme]);

  // Memoize the context value to prevent unnecessary re-renders
  const value = useMemo(
    () => ({ theme, updateTheme, getCurrentTheme }),
    [theme, updateTheme, getCurrentTheme]
  );

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};